import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";

type DbVaultKeys = Database["public"]["Tables"]["vault_keys"];
export type VaultKeyRow = DbVaultKeys["Row"];
export type VaultKeyInsert = DbVaultKeys["Insert"];
export type VaultKeyUpdate = DbVaultKeys["Update"];

async function fetchVaultKeyByUserId(userId: string): Promise<VaultKeyRow | null> {
  const { data, error } = await supabase
    .from("vault_keys")
    .select("id, salt, wrapped, iv, user_id, created_at, updated_at")
    .eq("user_id", userId)
    .single();

  if (error) throw error;
  return data;
}

async function addVaultKey(vaultKey: VaultKeyInsert): Promise<VaultKeyRow> {
  const { data, error } = await supabase
    .from("vault_keys")
    .insert([vaultKey])
    .select("id, salt, wrapped, iv, user_id, created_at, updated_at")
    .single();

  if (error) throw error;
  return data;
}

async function updateVaultKey({
  userId,
  vaultKey,
}: {
  userId: string;
  vaultKey: Partial<VaultKeyUpdate>;
}): Promise<void> {
  const { error } = await supabase.from("vault_keys").update(vaultKey).eq("user_id", userId);

  if (error) throw error;
}

async function deleteVaultKey(userId: string) {
  const { data, error } = await supabase.from("vault_keys").delete().eq("user_id", userId);

  if (error) throw error;
  return data;
}

export const vaultKeysFetchers = {
  fetchVaultKeyByUserId,
  addVaultKey,
  updateVaultKey,
  deleteVaultKey,
};
